import type { CSSProperties } from 'react';

import type { Top } from '../entities/top';

import { UnitView } from './unit-view';

export type TopViewProps = {
  top: Top;
  style?: CSSProperties;
};

export function TopView({ top, style }: TopViewProps) {
  return (
    <div className="flex w-36 flex-col items-center gap-0.5" style={style}>
      <div className="flex flex-row flex-wrap justify-center gap-1 bg-gray-300 p-2">
        {top.units.map((unit) => (
          <UnitView key={unit.id} unit={unit} />
        ))}
      </div>

      <div className="truncate text-sm leading-6 text-gray-900">{top.id}</div>
    </div>
  );
}
